import React, { memo, FunctionComponent } from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import { Box, SelectField, Text, Label } from 'mdlkit';
import { useIntl, FormattedMessage } from 'react-intl';
import { StyledFlex, FocusShadowInputField } from '../../shared/Styles';
import { required } from '../../../utils/shared/validations';
import { ErrorMessage } from '../../../utils/shared/interfaces';
import { normalizeNumbersOnly } from '../../../utils/register/normalize';
import { MONTHS } from '../../../constants/months';

export const DOBGroup = styled(StyledFlex)`
  flex-direction: row;

  & > ${Box} {
    margin-left: 2%;
    margin-top: 0 !important;

    input {
      padding-right: 10px !important;
    }

    &:first-child {
      margin-left: 0;
      min-width: 100px;
    }

    #dobMonth {
      &:focus {
        box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #000000 !important;
      }
    }
  }
`;

interface Props {
  placeholder?: string;
  disabled?: boolean;
  dobFieldValidate?: (value: string) => ErrorMessage;
  labelId?: string;
}

const DOBField: FunctionComponent<Props> = ({
  placeholder,
  disabled = false,
  dobFieldValidate = required,
  labelId = 'dateOfBirth',
}: Props) => {
  const { formatMessage: f } = useIntl();

  return (
    <Box as="fieldset" width={1}>
      <Label as="legend">
        <FormattedMessage id={labelId} />
      </Label>

      {placeholder ? (
        <Text small color="gray" pl="xxs" align="left">
          {placeholder}
        </Text>
      ) : null}

      <DOBGroup mt="xs">
        <Box>
          <Field
            id="dobMonth"
            label={f({ id: 'month' })}
            name="dobMonth"
            validate={dobFieldValidate}
            component={SelectField}
            blank
            options={MONTHS}
            disabled={disabled}
          />
        </Box>
        <Box>
          <Field
            id="dobDay"
            label={f({ id: 'day' })}
            name="dobDay"
            validate={dobFieldValidate}
            component={FocusShadowInputField}
            inputMode="numeric"
            maxLength={2}
            parse={normalizeNumbersOnly}
            disabled={disabled}
          />
        </Box>
        <Box>
          <Field
            id="dobYear"
            label={f({ id: 'year' })}
            name="dobYear"
            validate={dobFieldValidate}
            component={FocusShadowInputField}
            inputMode="numeric"
            maxLength={4}
            parse={normalizeNumbersOnly}
            disabled={disabled}
          />
        </Box>
      </DOBGroup>
    </Box>
  );
};

export default memo(DOBField);
